import React, { useEffect, useState, useRef } from "react";
import "pages/Anonymity/Anonymity.scss";
import { Breadcrumb, Modal } from "react-bootstrap";
import EziLoader from "components/EziLoader";
import Axios from "utility/Axios";
import configURL from "config/config";
import { toast } from "react-toastify";
import DataTable from "components/DataTable";
import SweetSearch from "components/SweetSearch";
import { useNavigate, useParams } from "react-router-dom";
import '../../assets/scss/_ezi_modal.scss';
import Select from 'react-select';
import { outlineRemove } from 'utility/helper';
import { DndContext, closestCenter } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy, arrayMove } from "@dnd-kit/sortable";
import SortableMenuItem from "./SortableMenuItem";
import InsightDashboardPreview from "./InsightMenu/InsightDashboardPreview";
import EmptyDashboardState from "./ReportMenus/EmptyDashboardState";
import QuestionAnalysisPreview from './ReportMenus/QuestionAnalysisPreview';
import RespondentPreview from "./ReportMenus/RespondentPreview";
import ResponseRatePreview from "./ReportMenus/ResponseRatePreview";
import CultureMapPreview from "./ReportMenus/CultureMapPreview";
import DownloadReportPreview from "./ReportMenus/DownloadReportPreview";
import TrendPreview from "./CeodbMenus/TrendPreview";
import OverviewPreview from "./CeodbMenus/OverviewPreview";
import AllCommentsPreview from "./CeodbMenus/AllCommentsPreview";
import MoodOMeterPreview from "./CeodbMenus/MoodOMeterPreview";
import DemographicComparator from "./CeodbMenus/DemographicComparator";
import StatementWisePreview from "./CeodbMenus/StatementWisePreview";

const ReportMenuVisibility = () => {
    const [pagination, setPagination] = useState({});
    const [loading, setLoading] = useState(false);
    const [searchLoading, setSearchLoading] = useState(false);
    const [reportList, setReportList] = useState([]);
    const [dataColumn, setDataColumn] = useState([{}]);
    const [showModal, setShowModal] = useState(false);
    const [selectedReportID, setSelectedReportID] = useState(null);
    const [selectedMenu, setSelectedMenu] = useState([]);
    const [selectedMenuOption, setSelectedMenuOption] = useState([]);
    const [insightConfig, setInsightConfig] = useState(null);
    const [reportConfiguration, setReportConfiguration] = useState({ average_toggle: false, date_range: "daterange" });
    const [activePreviewMenu, setActivePreviewMenu] = useState(null);
    const [selectedRowMasterConfig, setSelectedRowMasterConfig] = useState(null);
    const [masterOptions, setMasterOptions] = useState([]);
    const [pendingRow, setPendingRow] = useState(null);
    const [reportName, setReportName] = useState("");
    const inputSearch = useRef(null);
    const navigate = useNavigate();
    let urlParams = useParams();
    var searchTimer = null;
    const per_page = 10;
    const sortableItems = selectedMenu?.map(item => item?.label)

    /* ---------------- HELPERS ---------------- */

    const formateSelectMenuOption = (menuObj) => {
        if (!menuObj?.label) return "";
        return menuObj.label
            .toLowerCase()
            .split('_')
            .map(w => w.charAt(0).toUpperCase() + w.slice(1))
            .join(' ');
    };

    /* ---------------- OPEN MODAL (UPDATED) ---------------- */

    const handleEditSurveySetting = (row = {}) => {
        if (!row) return;
        setReportName(row?.title)
        setPendingRow(row);
        setShowModal(true);
    };


    /* ---------------- SELECT MENU ---------------- */
    const handleReportMenuSelect = (value, actionMeta) => {
        const selected = Array.isArray(value) ? value : [];
        setSelectedMenu(selected);
        if (selected.length > 0) {
            setActivePreviewMenu(selected[0].label);
        } else {
            setActivePreviewMenu(null);
        }
        if (actionMeta?.action === "select-option") {
            const selectedKeys = selected.map(s => s.value.key);
            setSelectedMenuOption(prev =>
                prev.filter(opt => !selectedKeys.includes(opt.value.key))
            );
        }
        if (actionMeta?.action === "remove-value" || actionMeta?.action === "pop-value") {
            const removed = actionMeta?.removedValue;
            if (removed?.value?.key) {
                setSelectedMenuOption(prev => {
                    const exists = prev.some(opt => opt.value.key === removed.value.key);
                    return exists ? prev : [...prev, removed];
                });
            }
        }

        if (actionMeta?.action === "clear") {
            if (!pendingRow || masterOptions.length === 0) return;
            const name = pendingRow.name ?? pendingRow.title ?? "";
            const key = name.replace(/-|\s/g, "");
            const matched = masterOptions.find(item => Object.keys(item)[0] === key);

            let masterMenuArray = [];

            if (matched && matched[key]) {
                const rawMenu = matched[key];

                if (Array.isArray(rawMenu)) masterMenuArray = rawMenu;
                else if (typeof rawMenu === "string") {
                    try {
                        const parsed = JSON.parse(rawMenu);
                        masterMenuArray = Array.isArray(parsed?.menu) ? parsed.menu : [];
                    } catch {
                        masterMenuArray = [];
                    }
                } else if (rawMenu?.menu && Array.isArray(rawMenu.menu)) {
                    masterMenuArray = rawMenu.menu;
                }
            }

            const allOptions = masterMenuArray.map(m => ({
                label: formateSelectMenuOption(m),
                value: m
            }));

            setSelectedMenu([]);
            setSelectedMenuOption(allOptions);
            setActivePreviewMenu(null);
        }
    };


    /* ---------------- DRAG REORDER ---------------- */

    const handleOnDragEnd = ({ active, over }) => {
        if (!over || active.id === over.id) return;

        setSelectedMenu(prev => {
            const labels = prev.map(item => item.label);
            const oldIndex = labels.indexOf(active.id);
            const newIndex = labels.indexOf(over.id);

            const newOrderLabels = arrayMove(labels, oldIndex, newIndex);

            const map = Object.fromEntries(prev.map(item => [item.label, item]));
            return newOrderLabels.map(label => map[label]).filter(Boolean);
        });
    };

    /* ---------------- SAVE (UNCHANGED PAYLOAD) ---------------- */

    const saveReportWiseMenu = () => {
        if (!Array.isArray(selectedMenu) || selectedMenu.length === 0) {
            toast.warn("Please select at least one menu");
            return;
        }
        if(selectedMenu?.find(menu => menu?.label === "Insight")){
            if(!insightConfig.speedometer && insightConfig.tabs.length === 0){
                toast.warn("Please Select atleast one widget for the Insight.")
                return;
            }
        }
        const menu = selectedMenu.map(item => item.value);
        let menu_components = {};
        if (insightConfig) {
            menu_components = {
                insights: {
                    tabs: Array.isArray(insightConfig.tabs) ? insightConfig.tabs : [],
                    speedometer: !!insightConfig.speedometer,
                    score_widgets: !!insightConfig.score_widgets
                }
            };
        }
        const ReportConfiguration = {
            average_toggle: !!reportConfiguration?.average_toggle || false,
            date_range: reportConfiguration?.date_range || "daterange"
        };
        const ui_config_obj = {
            menu,
            menu_components,
            ReportConfiguration
        };

        const ui_config_string = JSON.stringify(ui_config_obj);
        const finalMasterConfig = {
            ...selectedRowMasterConfig,
            ui_config: ui_config_string
        };
        let formData = new FormData();
        formData.append("report_type_json", JSON.stringify([{ report_type_id: selectedReportID, master_configuration_json: finalMasterConfig }]));
        Axios.post(configURL.manage_partner_report_types_mapping, formData)
            .then((response) => {
                if (response.data.success === true) {
                    getReportType();
                    setShowModal(false);
                    setSelectedMenu([]);
                    setSelectedReportID(null);
                    setActivePreviewMenu(null);
                    toast.success(response.data.message);
                } else {
                    toast.warn(response.data.message);
                }
            });
    };

    /* ---------------- PREVIEW (SAME AS FIRST COMPONENT) ---------------- */

    const renderPreview = () => {
        if (!activePreviewMenu) return <EmptyDashboardState />;
        switch (activePreviewMenu.toLowerCase()) {
            case "insight":
                return <InsightDashboardPreview insightConfig={insightConfig} reportConfiguration={reportConfiguration} />;
            case "response rate":
                return <ResponseRatePreview />;
            case "respondent report":
                return <RespondentPreview />;
            case "culturemap":
                return <CultureMapPreview />;
            case "question analysis":
                return <QuestionAnalysisPreview />;
            case "download report":
                return <DownloadReportPreview />;
            case "overview":
                return <OverviewPreview />;
            case "employee comments":
                return <AllCommentsPreview />;
            case "mood-o-meter":
                return <MoodOMeterPreview />;
            case "demographic comparators":
                return <DemographicComparator />;
            case "statement wise":
                return <StatementWisePreview />;
            case "trends":
                return <TrendPreview />;
            default:
                return (
                    <div className="text-muted text-center mt-5">
                        Preview not available for this menu
                    </div>
                );
        }
    };

    /* ---------------- TABLE ---------------- */

    const headingFormatter = () => {
        return <div className="action-heading-name"> Action </div>;
    };

    const actionFormatter = (cell, row) => {
        return (
            <div className="dt-bootstrap-edit-delte-wrap">
                <button
                    type="button"
                    className="action-btn"
                    onClick={() => handleEditSurveySetting(row)}
                    title="Assign"
                > Assign </button>
            </div>
        );
    };

    const handleTableChange = (type, props) => {
        setLoading(true);
        switch (type) {
            case "pagination":
                getReportType(props.page);
                break;
            case "sort":
                getReportType();
                break;
            default:
                break;
        }
    };

    const getReportType = (page = 1) => {
        let formData = new FormData();
        let userSearch = inputSearch.current.value;
        formData.append("page", page);
        formData.append("per_page", per_page);
        formData.append("search", userSearch);
        formData.append("is_partner_report_type", true);
        urlParams?.account_id && formData.append("account_id", urlParams?.account_id);
        Axios.post(configURL.get_partner_report_types_mapping, formData).then((response) => {
            if (response.data.success === true) {
                const columnData = [{ dataField: "name", text: "Report Type" }, { dataField: "title", text: "Display Title" }];
                columnData.push({
                    dataField: "action",
                    text: "Action",
                    headerFormatter: headingFormatter,
                    formatter: actionFormatter,
                });
                let tableData = response.data.data.map((item) => {
                    let name = item.name;
                    let report_type_id = item.report_type_id;
                    let master_configuration_json = item.master_configuration_json;
                    return { ...item.master_configuration_json, name, report_type_id, master_configuration_json };
                });
                setDataColumn(columnData);
                setReportList(tableData);
                setPagination(response.data.pagination);
                setLoading(false);
                setSearchLoading(false);
            } else {
                toast.warn(response.data.message);
            }
        });
    };

    const handleTableSearch = () => {
        clearTimeout(searchTimer);
        searchTimer = setTimeout(() => {
            setSearchLoading(true);
            getReportType();
        }, 500);
    };

    const reportListing = () => {
        setLoading(true);
        let formData = new FormData();
        if (inputSearch.current.value !== "") {
            formData.append("search", inputSearch?.current?.value);
        }
        Axios.post(configURL.report_listing, formData).then(res => {
            if (res.data.success) {
                let selectedMenus = res?.data?.result.map((item) => ({
                    [item?.name.replace(/-|\s/g, "")]:
                        item?.ui_config && JSON.parse(item?.ui_config)
                }));
                setMasterOptions(selectedMenus);
                setLoading(false);
            } else {
                toast.warn(res.data.message || 'Something went wrong');
                setLoading(false);
            }
        });
    };

    useEffect(() => {
        // Run only when modal is opened AND masterOptions is ready AND row is set
        if (!showModal) return;
        if (!pendingRow) return;
        if (!Array.isArray(masterOptions) || masterOptions.length === 0) return;

        const row = pendingRow;
        setSelectedReportID(row?.report_type_id);
        const name = row.name ?? row?.title ?? "";
        const key = name.replace(/-|\s/g, "");
        let masterMenuArray = [];
        const matched = masterOptions.find(item => Object.keys(item)[0] === key);
        if (matched && matched[key]) {
            const rawMenu = matched[key];
            if (Array.isArray(rawMenu)) {
                masterMenuArray = rawMenu;
            }
            else if (typeof rawMenu === "string") {
                try {
                    const parsed = JSON.parse(rawMenu);
                    if (Array.isArray(parsed?.menu)) {
                        masterMenuArray = parsed.menu;
                    }
                } catch (e) {
                    masterMenuArray = [];
                }
            }
            else if (rawMenu?.menu && Array.isArray(rawMenu.menu)) {
                masterMenuArray = rawMenu.menu;
            }
        }
        const allOptions = masterMenuArray.map(m => ({
            label: formateSelectMenuOption(m),
            value: m
        }));
        let selected = [];
        let uiCfg = null;
        let existingInsight = null;
        let existingReportConfig = { average_toggle: false, date_range: "daterange" };
        try {
            uiCfg = row?.master_configuration_json?.ui_config;
            if (typeof uiCfg === "string") {
                uiCfg = JSON.parse(uiCfg);
            }
            if (Array.isArray(uiCfg?.menu)) {
                selected = uiCfg.menu.map(m => ({
                    label: formateSelectMenuOption(m),
                    value: m
                }));
            }
            const insightBlock = uiCfg?.menu_components?.insights || uiCfg?.menu_components?.insight ||
                null;
            if (insightBlock) {
                existingInsight = {
                    tabs: Array.isArray(insightBlock.tabs) ? insightBlock.tabs : [],
                    speedometer: !!insightBlock.speedometer,
                    score_widgets: !!insightBlock.score_widgets
                };
            }
            existingReportConfig = { average_toggle: uiCfg?.ReportConfiguration.average_toggle || false, date_range: uiCfg?.ReportConfiguration?.date_range || "daterange" };
        } catch (e) {
            selected = [];
            existingInsight = null;
            existingReportConfig = { average_toggle: false, date_range: "daterange" };
        }
        const selectedKeys = selected.map(s => s.value?.key).filter(Boolean);
        const filteredOptions = allOptions.filter(
            opt => !selectedKeys.includes(opt.value?.key)
        );
        setSelectedMenu(selected);
        setSelectedMenuOption(filteredOptions);
        setSelectedRowMasterConfig({ ...row.master_configuration_json });
        setInsightConfig(existingInsight);
        setReportConfiguration(existingReportConfig);
        if (selected.length > 0) {
            setActivePreviewMenu(selected[0].label);
        } else {
            setActivePreviewMenu(null);
        }
    }, [showModal, masterOptions, pendingRow]);


    useEffect(() => {
        if (selectedMenu?.length > 0 && !activePreviewMenu) {
            setActivePreviewMenu(selectedMenu[0].label);
        }
    }, [selectedMenu]);

    useEffect(() => {
        setLoading(true);
        getReportType();
        reportListing();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <React.Fragment>
            <section className="Page-Users">
                <div className="breadcrumb_ezi">
                    <Breadcrumb>
                        <Breadcrumb.Item onClick={() => navigate('/dashboard')}>Dashboard</Breadcrumb.Item>
                        <Breadcrumb.Item>Report Menu Visibility</Breadcrumb.Item>
                    </Breadcrumb>
                    <div className="column-header">
                        <h1 className="page-heading">Report Wise Menu Visibility</h1>
                    </div>
                </div>
                <div className="users-table-content">
                    <SweetSearch
                        ref={inputSearch}
                        change={handleTableSearch}
                        loading={searchLoading} />
                    {reportList.length > 0 && dataColumn.length > 0 && (
                        <div className="saved_participants_table">
                            <DataTable
                                data={reportList}
                                columns={dataColumn}
                                hideSelectAll
                                page={pagination.current_page}
                                sizePerPage={per_page}
                                onTableChange={handleTableChange}
                                keyField="id"
                                totalSize={pagination.total}
                                hideSelect
                            />
                        </div>
                    )}
                    {reportList.length === 0 && (
                        <div className="saved_participants_table">
                            <DataTable data={[]} columns={[{}]} keyField="id" hideSelect />
                        </div>
                    )}
                </div>
                {showModal && (
                    <Modal
                        show={showModal}
                        className="ezi-modal-wrapper theme-modal-wrapper report-wise-menu-modal"
                        size="xl"
                        centered>
                        <Modal.Header className="ezi-modal-header">
                            <Modal.Title className="theme-modal-title ezi-modal-header-title">
                                <span className="theme-modal-title-text">Select menu and arrange </span>
                                <span
                                    className="ezi-modal-close"
                                    onClick={() => {
                                        setShowModal(false);
                                        setActivePreviewMenu(null);
                                    }} />
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="row h-100">
                                <div className="col-md-3 border-end pe-3">
                                    <h6 className="mb-3">{reportName}</h6>
                                    <Select
                                        isMulti
                                        options={selectedMenuOption}
                                        value={selectedMenu}
                                        placeholder="Select dashboard menus..."
                                        onChange={handleReportMenuSelect}
                                        styles={outlineRemove} />
                                    <div className="mt-3">
                                        <DndContext
                                            collisionDetection={closestCenter}
                                            onDragEnd={handleOnDragEnd} >
                                            <SortableContext
                                                items={sortableItems}
                                                strategy={verticalListSortingStrategy}>
                                                {sortableItems.map(item => (
                                                    <SortableMenuItem
                                                        key={item}
                                                        id={item}
                                                        isInsight={item.toLowerCase() === "insight" || item.toLowerCase() === "insights"}
                                                        insightConfig={insightConfig}
                                                        onInsightChange={setInsightConfig}
                                                        onReportConfigChange={setReportConfiguration}
                                                        reportConfiguration={reportConfiguration}
                                                        isActive={activePreviewMenu === item}
                                                        onSelectPreview={setActivePreviewMenu}
                                                    />
                                                ))}
                                            </SortableContext>
                                        </DndContext>
                                    </div>
                                </div>
                                <div className="col-md-9 ps-4 bg-light">
                                    <h6 className="mb-3">
                                        Dashboard Preview
                                        {activePreviewMenu && (
                                            <span className="text-muted ms-2">
                                                ({activePreviewMenu})
                                            </span>)}
                                    </h6>
                                    {/* Radio button Below for selecting the Date range */}
                                    <div className="mb-3 d-flex me-2 align-items-center">
                                        <h6 className="mb-2 me-3">Default Date Range: </h6>

                                        {[{ label: "Date Range", value: "daterange" },
                                        { label: "Last 7 Days", value: "7days" },
                                        { label: "Last 30 Days", value: "30days" },
                                        { label: "Last 90 Days", value: "90days" }
                                        ].map(opt => (
                                            <div className="form-check me-2" key={opt.value}>
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="defaultDateRange"
                                                    id={`date-range-${opt.value}`}
                                                    checked={reportConfiguration?.date_range === opt.value}
                                                    onChange={() =>
                                                        setReportConfiguration(prev => ({
                                                            ...prev,
                                                            date_range: opt.value
                                                        }))
                                                    }
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor={`date-range-${opt.value}`}
                                                >
                                                    {opt.label}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                    {renderPreview()}
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <button
                                className="close-theme-btn"
                                onClick={() => {
                                    setShowModal(false);
                                    setActivePreviewMenu(null);
                                }}>Close </button>
                            <input
                                type="submit"
                                value="Save"
                                onClick={saveReportWiseMenu}
                                className="btn-ripple ezi-pink-btn add-theme-btn"
                            />
                        </Modal.Footer>
                    </Modal>)}
            </section>
            {loading && <EziLoader />}
        </React.Fragment>
    );
};

export default ReportMenuVisibility;